import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface InitStata {
  number: number;
  modelConfigId: number;
}

const initialState: InitStata = {
  number: 0,
  modelConfigId: -1,
};

const customerSlice = createSlice({
  name: 'youth',
  initialState,
  reducers: {
    changeCount: (state = initialState, action: PayloadAction<number>) => {
      state.number = action.payload;
    },
    changeCurModelId: (state = initialState, action: PayloadAction<number>) => {
      state.modelConfigId	 = action.payload;
    },
  },
});

// 导出action
export const {
  changeCount,
  changeCurModelId
} = customerSlice.actions;

export default customerSlice.reducer;
